<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("reports.analyticsAndReporting") }}</h2>
      </div>
      <v-card elevation="0" class="">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="3" class="px-1">
              <v-select
              :loading="countryLoading"
              :items="countries"
              item-text="name"
              item-value="id"
              dense
              outlined
              v-model="filterData.country"
              :placeholder="$t('reports.filterByCountry')"
              @change="getStates(filterData.country)"
            ></v-select>
            </v-col>
            <v-col cols="3" class="px-1">
              <v-select
              :loading="stateLoading"
              :items="regions"
              item-text="name"
              item-value="id"
              dense
              outlined
              v-model="filterData.region"
              :placeholder="$t('reports.filterByRegion')"
            ></v-select>
            </v-col>
            <v-col cols="3" class="px-1">
              <FarmDropdown 
                v-model="filterData.farm"
              /> 
              <!-- <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              v-model="region"
              :placeholder="$t('reports.filterByFarm')"
            ></v-select> -->
            </v-col>
            <v-col cols="3" class="px-1">
              <v-select
              :items="breeds"
              dense
              outlined
              v-model="filterData.breed"
              :placeholder="$t('reports.filterByTrait')"
            ></v-select>
            </v-col>
            
            
            
            
            <!-- <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="shrink mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByYear')"
            ></v-select> -->
          </v-row>
          <v-card flat elevation="0" class="px-2 py-2" outlined>
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title>{{ $t('animal.healthRecordInfo.animalHealthRecord') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <template v-slot:top> -->
              <!-- <div display="flex"> -->
              <!-- <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                placeholder="Search"
                dense
                class="shrink"
              ></v-text-field> -->
              <v-btn
                :disabled="healthOptions.page <= 1"
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="pageHealthChange(false)"
                style="margin-bottom: 10px"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                :disabled="healthOptions.page >= totalHealthPages"
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="pageHealthChange(true)"
                style="margin-bottom: 10px"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <!-- </div> -->
              <!-- </template> -->
              <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="exporthealth"
              >
                <v-icon dark> mdi-export </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="
                  printPDF(
                    $refs.health,
                    'Animal Health Record(Analytics and Reporting Report)'
                  )
                "
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0" ref="health">
              <v-data-table
                :headers="healthHeaders"
                :items="healthData"
                :items-per-page="5"
                hide-default-footer
                :loading="loadingHealth"
                loading-text="Loading Data..."
                :options.sync="healthOptions"
                :server-items-length="totalHealth"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="6"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:no-data v-if="healthData.length < 1">
                  {{ $t("noDataAvailable") }}
                </template>

                <template v-if="healthData.length > 0" v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.drugId">
                      <td>{{ item.animalNumber }}</td>
                      <td>{{ item.drugId }}</td>
                      <td>{{ item.diagnosis }}</td>
                      <td>{{ item.drugName }}</td>
                      <td>{{ item.drugWithdrawPeriod }}</td>
                      <td>{{ item.treatmentDate }}</td>
                    </tr>
                  </tbody>
                </template>
                <!-- 
                <template v-slot:footer></template> -->
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-card flat elevation="0" outlined class="mt-5">
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title>{{ $t('animal.healthRecordInfo.animalTreatmentRecord') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="treatmentOptions.page <= 1"
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="pageTreatmentChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                :disabled="treatmentOptions.page >= totalTreatmentPages"
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="pageTreatmentChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="exportreatment"
              >
                <v-icon dark> mdi-export </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="
                  printPDF(
                    $refs.treatment,
                    'Animal Treatment Record(Analytics and Reporting Report)'
                  )
                "
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <div ref="treatment">
                <v-data-table
                  :headers="treatmentHeaders"
                  :items="treatmentData"
                  :items-per-page="5"
                  hide-default-footer
                  :loading="loadingTreatment"
                  loading-text="Loading Data..."
                  :options.sync="treatmentOptions"
                  :server-items-length="totalTreatment"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      color="primary"
                      :height="6"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:no-data v-if="healthData.length < 1">
                    {{ $t("noDataAvailable") }}
                  </template>
                  <template
                    v-if="treatmentData.length > 0"
                    v-slot:body="{ items }"
                  >
                    <tbody>
                      <tr v-for="item in items" :key="item.animalNumber">
                        <td>{{ item.animalNumber }}</td>
                        <td>{{ item.attendingVeterinarian }}</td>
                        <td>{{ item.treatment }}</td>
                        <td>{{ item.treatmentReason }}</td>
                        <td>{{ item.treatmentDate }}</td>
                      </tr>
                    </tbody>
                  </template>
                  <!-- <template v-slot:footer></template> -->
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
          <v-row>
            <v-col cols="6">
              <v-card flat elevation="0" outlined class="mt-5">
                <v-toolbar dense flat :elevation="0">
                  <v-toolbar-title>{{ $t("animal.animalInseminationRecord") }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    :disabled="inseminatorOptions.page <= 1"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="inseminatorOptions.page >= 10"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn> -->

                  <v-btn icon>
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportinsemination"
                  >
                    <v-icon dark> mdi-export </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="
                      printPDF(
                        $refs.insemi,
                        'Animal Insemination Record(Analytics and Reporting Report)'
                      )
                    "
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <div ref="insemi">
                    <v-data-table
                      :headers="insemintorHeaders"
                      :items="inseminatorData"
                      :items-per-page="5"
                      hide-default-footer
                      :loading="loadingInseminator"
                      loading-text="Loading Data..."
                      :options.sync="inseminatorOptions"
                      :server-items-length="5"
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          color="primary"
                          :height="6"
                          indeterminate
                        ></v-progress-linear>
                      </template>
                      <template
                        v-slot:no-data
                        v-if="inseminatorData.length < 1"
                      >
                        {{ $t("noDataAvailable") }}
                      </template>
                      <template
                        v-if="inseminatorData.length > 0"
                        v-slot:body="{ items }"
                      >
                        <tbody>
                          <tr v-for="item in items" :key="item.animalNumber">
                            <td>{{ item.inseminatorNumber }}</td>
                            <td>{{ item.inseminatorName }}</td>
                            <td>{{ item.conceptionRate }}</td>
                            <td>{{ item.dateOfMeasurement }}</td>
                          </tr>
                        </tbody>
                      </template>
                      <!-- <template v-slot:footer></template> -->
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card flat elevation="0" outlined class="mt-5">
                <v-toolbar dense flat :elevation="0">
                  <v-toolbar-title>{{ $t("reportings.animalVaccinationRecord") }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    :disabled="healthOptions.page <= 1"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="healthOptions.page >= 10"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn> -->
                  <v-btn icon>
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportvaccine"
                  >
                    <v-icon dark> mdi-export </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="
                      printPDF(
                        $refs.vaccine,
                        'Animal Vaccination Record(Analytics and Reporting Report)'
                      )
                    "
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <div ref="vaccine">
                    <v-data-table
                      :headers="healthHeaders"
                      :items="healthData"
                      :items-per-page="5"
                      hide-default-footer
                      :loading="loadingHealth"
                      loading-text="Loading Health Data..."
                      :options.sync="healthOptions"
                      :server-items-length="totalHealth"
                    >
                      <template v-slot:footer></template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import HealthReport from "@/_services/AnalyticsService";
import InsemiService from "@/_services/InsemnatorService";
import FarmService from "@/_services/farmService";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
// import countries from "@/models/countries.js"
import { breeds } from "@/models/units.js";
import FarmDropdown from "@/components/FarmDropdown.vue";


export default {
  components: {
    FarmDropdown
  },
  mounted() {
    document.title = this.$t('reports.analyticsAndReporting');
  },
  computed: {},
  created() {
    this.getCountries()
  },
  watch: {
    filterData: {
      handler() {
        this.getAnimalHealthReport();
        this.getAnimalTreatmentReport();
        this.getAnimalInseminatorReport();
      },
      deep:true
    },
    healthOptions: {
      handler() {
        this.getAnimalHealthReport();
      },
      deep: true,
    },
    treatmentOptions: {
      handler() {
        this.getAnimalTreatmentReport();
      },
      deep: true,
    },
    inseminatorOptions: {
      handler() {
        this.getAnimalInseminatorReport();
      },
      deep: true,
    },
  },
  methods: {
    getCountries() {
      this.countryLoading=true
      FarmService.loadCountries().then((data) => {
        this.countries = data.data;
        this.countryLoading=false
      });
    },
    getStates(id) {
      this.stateLoading=true
      if(!id) return 
      FarmService.loadStates(id).then((data) => {
        this.regions = data.data.length!==0 ? data.data:{id:"0",name:"No state available"};
        this.stateLoading=false
      });
    },
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getAnimalHealthReport() {
      this.loadingHealth = true;
      HealthReport.getHealthReport(this.healthOptions, "", this.filterData)
        .then((res) => {
          this.healthData = res.data.data.healthRecord.rows;
          this.totalHealth = res.data.data.healthRecord.total_rows;
          this.totalHealthPages = Math.ceil(
            this.totalHealth / this.healthOptions.itemsPerPage
          );
          this.healthFrom =
            (this.healthOptions.page - 1) * this.healthOptions.itemsPerPage + 1;
          this.healthTo =
            this.healthOptions.page * this.healthOptions.itemsPerPage -
            (this.healthOptions.itemsPerPage - res.data.data.healthRecord.num_rows);
          this.loadingHealth = false;
        })
        .catch((err) => {
          this.loadingHealth = false;
          console.log(err);
        });
    },
    getAnimalTreatmentReport() {
      this.loadingTreatment = true;
      HealthReport.getTreatmentReport(this.treatmentOptions, "", this.filterData)
        .then((res) => {
          this.loadingTreatment = false;
          this.treatmentData = res.data.data.treatmentRecord.rows;
          this.totalTreatment = res.data.data.treatmentRecord.total_rows;
          this.totalTreatmentPages = Math.ceil(
            this.totalTreatment / this.treatmentOptions.itemsPerPage
          );
          this.treatmentFrom =
            (this.treatmentOptions.page - 1) *
              this.treatmentOptions.itemsPerPage +
            1;
          this.treatmentTo =
            this.treatmentOptions.page * this.treatmentOptions.itemsPerPage -
            (this.treatmentOptions.itemsPerPage -
              res.data.data.treatmentRecord.num_rows);
          this.loadingHealth = false;
        })
        .catch((err) => {
          this.loadingTreatment = false;
          console.log(err);
        });
    },
    getAnimalInseminatorReport() {
      this.loadingInseminator = true;
      // HealthReport.getInseminatorReport(this.inseminatorOptions, "")
      InsemiService.getInseminatorInfo(this.inseminatorOptions, "")
        .then((res) => {
          console.log('iiiii', res)
          this.loadingInseminator = false;
          // this.inseminatorData = res.data.data.insemenationRecord.rows;
          this.inseminatorData = res.data.inseminatorStatistic.rows;
          //   this.totalInseminator = res.data.animalConception.totalRows;
        })
        .catch((err) => {
          this.loadingInseminator = false;
          console.log(err);
        });
    },
    pageHealthChange(t) {
      if (t) this.healthOptions.page = this.healthOptions.page + 1;
      else this.healthOptions.page = this.healthOptions.page - 1;

      // this.getAnimalHealthReport();
    },
    pageTreatmentChange(t) {
      if (t) this.treatmentOptions.page = this.treatmentOptions.page + 1;
      else this.treatmentOptions.page = this.treatmentOptions.page - 1;

      this.getAnimalTreatmentReport();
    },
    exporthealth() {
      html2pdf(this.$refs.health, {
        margin: 1,
        filename: "Health Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportreatment() {
      html2pdf(this.$refs.treatment, {
        margin: 1,
        filename: "Treatment Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportinsemination() {
      html2pdf(this.$refs.insemi, {
        margin: 1,
        filename: "Insemination Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportvaccine() {
      html2pdf(this.$refs.vaccine, {
        margin: 1,
        filename: "Vaccination Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
  },
  data() {
    return {
      countryLoading: false,
      stateLoading: false,
      loadingHealth: false,
      loadingTreatment: false,
      loadingInseminator: false,
      countries: [],
      breeds,
      regions: [],
      totalHealthPages: 0,
      totalTreatmentPages: 0,
      filterData:{
        country: null,
        region: null,
        farm: null,
        breed: null,
      },
      healthFrom: 0,
      healthTo: 0,
      treatmentFrom: 0,
      treatmentTo: 0,
      totalHealth: 0,
      totalTreatment: 0,
      totalInseminator: 0,
      healthOptions: {},
      treatmentOptions: {},
      inseminatorOptions: {},
      healthHeaders: [
        {
          text: this.$t('animal.animalID'),
          align: "start",
          sortable: false,
          value: "animalNumber",
        },
        { text: this.$t('animal.healthRecordInfo.drugID'), value: "drugId" },
        { text: this.$t('animal.healthRecordInfo.nameOfDiagnosis'), value: "diagnosis" },
        { text: this.$t('drug.drugName'), value: "drugName" },
        { text: this.$t('animal.healthRecordInfo.drugWithdrawalPeriod'), value: "drugWithdrawPeriod" },
        { text: this.$t('animal.healthRecordInfo.treatmentDate'), value: "treatmentDate" },
        // { text: "Recovery Status", value: "recoveryStatus" },
      ],
      treatmentHeaders: [
        {
          text: this.$t('animal.animalID'),
          align: "start",
          sortable: false,
          value: "animalNumber",
        },
        { text: this.$t('animal.healthRecordInfo.drugGivenBy'), value: "attendingVeterinarian" },
        { text: this.$t('animal.healthRecordInfo.treatmentName'), value: "treatment" },
        { text: this.$t('animal.healthRecordInfo.reasonOfTreatment'), value: "treatmentReason" },
        { text: this.$t('animal.healthRecordInfo.treatmentDate'), value: "treatmentDate" },
        // { text: "Recovery Status", value: "recoveryStatus" },
      ],
      insemintorHeaders: [
        {
          text: this.$t('actionListmod.inseminatorId'),
          align: "start",
          sortable: false,
          value: "inseminatorStatisticNo",
          width: '150px'
        },
        { text: this.$t('dashboardS.inseminatorName'), value: "inseminatorName", width: '170px' },
        { text: this.$t('actionListmod.conceptionRate'), value: "conceptionRate", width: '170px' },
        { text: this.$t('actionListmod.dateOfmeasurement'), value: "dateOfMeasurement" , width: '200px'},
      ],
      healthData: [],
      treatmentData: [],
      inseminatorData: [],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reportings.healthReport'),
          disabled: true,
        },
      ],
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
</style>